module.exports = __webpack_public_path__ + "teenagersMobile.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/preview-popup/assets/teenagersMobile.png
// module id = 1180
// module chunks = 10